module.exports = __webpack_public_path__ + "static/img/head2_tr.1b95fa85.png";